const PlaceDropdownIcon = () => {
  return (
    <svg
      width='9'
      height='7'
      viewBox='0 0 9 7'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path d='M4.5 7L0.602887 0.249999L8.39711 0.25L4.5 7Z' />
    </svg>
  )
}

export default PlaceDropdownIcon
